//
// Search Clear Filters
//
// Clears any filters applied to a search box and submits the form.
// ---------------------------------------------------------------------------

'use strict';

const config = {
    target: '.js-search-clear-filters',
    filter: ':checkbox'
};

let resetLink = $(config.target);
let form = resetLink.closest('form');

$('body').on('click', config.target, function(e) {
    e.preventDefault();

    // Clear checkboxes
    let filters = form.find(config.filter);
    if (filters.length) {
        filters.removeAttr('checked');
    }

    // Submit form
    form.submit();
});



// WEBPACK FOOTER //
// ./src/js/components/search-clear-filters.js